/**
 * Firebase web config. All of it is public by design and ships in the bundle.
 *
 * The `apiKey` is NOT a secret, despite the name — it identifies the project to
 * Google's auth endpoints and nothing more. It grants no access on its own:
 * everything it can reach is guarded by Firebase's own rules and, here, by our
 * `authorize()` chokepoint on a token the server verifies independently. Google
 * documents it as safe to include in client code. Treating it as a secret would
 * be cargo cult; treating anything ELSE here as safe would be a breach.
 *
 * The test for what belongs in this file is not "is it sensitive" but "does the
 * browser need it to start a sign-in". Nothing else qualifies.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    // Fail at module load, in the console, naming the variable — rather than
    // rendering a shell that half-works and fails on click.
    throw new Error(`${name} is not set. Copy .env.example to .env.local.`);
  }
  return value;
}

export const FIREBASE_CONFIG = {
  apiKey: required("VITE_FIREBASE_API_KEY", import.meta.env.VITE_FIREBASE_API_KEY),
  authDomain: required("VITE_FIREBASE_AUTH_DOMAIN", import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
  projectId: required("VITE_FIREBASE_PROJECT_ID", import.meta.env.VITE_FIREBASE_PROJECT_ID),
  appId: required("VITE_FIREBASE_APP_ID", import.meta.env.VITE_FIREBASE_APP_ID),
} as const;

/**
 * Points the browser SDK at the Auth emulator for local development.
 *
 * Only ever set in a local .env; it is not in any deploy config. The server has
 * its own, harder guard — it refuses to boot in production with the emulator
 * configured — because that is where a bypass would actually matter.
 */
export const AUTH_EMULATOR_HOST = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST as
  | string
  | undefined;
